"use client";
import React from "react";
import { motion } from "framer-motion";
import { Caveat } from "next/font/google";
import Image from "next/image";

const caveat = Caveat({ subsets: ["latin"], weight: ["400", "700"], display: "swap" });

export default function IndustryServiceManagement({ section }) {
  return (
    <section className="py-24 px-6 sm:px-12 lg:px-24 relative overflow-visible">
      <div className="container mx-auto text-center relative">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-white/5 rounded-full -z-0" />

        <div className="max-w-3xl mx-auto mb-20 relative z-10">
          <h2 className={`text-4xl md:text-6xl font-bold mb-8 leading-tight text-white`}>
            <span className={`text-orange-400 border-b-4 border-orange-200 ${caveat.className}`}>{section.title.split(" ")[0]}</span> {section.title.split(" ").slice(1).join(" ")}
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed">
            <strong className="text-white">{section.subtext.split(" ").slice(0, 4).join(" ")}</strong>
            {section.subtext.substring(section.subtext.indexOf("project") - 3)}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-4xl mx-auto relative z-10">
          <div className="space-y-12">
            <motion.div className="flex flex-col items-center">
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-white/10 mb-6 bg-white/5 relative">
                <Image src={section.items[0].image} width={400} height={300} className="w-full h-auto object-cover" alt="" />
              </div>
              <em className={`text-white text-2xl ${caveat.className} relative`}>
                {section.items[0].label}
                <div className="absolute -top-12 -right-16 w-12 h-12 rotate-[220deg] opacity-10">
                  <Image src="/odoo/arrows/grey_arrow_md_03.svg" fill className="object-contain" alt="" />
                </div>
              </em>
            </motion.div>

            <motion.div className="flex flex-col items-center">
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-white/10 mb-6 bg-white/5 relative">
                <Image src={section.items[1].image} width={400} height={300} className="w-full h-auto object-cover" alt="" />
              </div>
              <em className={`text-white text-2xl ${caveat.className} relative`}>
                {section.items[1].label}
                <div className="absolute -top-12 -left-16 w-12 h-12 rotate-[60deg] opacity-10">
                  <Image src="/odoo/arrows/grey_arrow_md_03.svg" fill className="object-contain" alt="" />
                </div>
              </em>
            </motion.div>
          </div>

          <div className="flex flex-col items-center">
            <motion.div className="flex flex-col items-center">
              <em className={`text-white text-2xl ${caveat.className} relative mb-6`}>
                {section.items[2].label}
                <div className="absolute top-12 -left-16 w-12 h-12 rotate-[300deg] opacity-10">
                  <Image src="/odoo/arrows/grey_arrow_md_03.svg" fill className="object-contain" alt="" />
                </div>
              </em>
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-white/10 bg-white/5 relative">
                <Image src={section.items[2].image} width={400} height={400} className="w-full h-auto object-cover" alt="" />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
